import { useEffect } from 'react'

export const HelpScoutBeacon = () => {
  useEffect(() => {
    // Handle SSR
    if (typeof window === 'undefined') {
      return false
    }

    // If we're using a minimal layout, do not initialise the beacon
    const ml =
      new URLSearchParams(window.location.search).get('minimal') === 'true'
    if (ml) {
      return
    }

    // This is the `Support (web)` Beacon - configured to go to the `Support` inbox on Helpscout
    window.Beacon('init', 'e463588d-c426-4ac5-99ae-b2eaf2850675')

    // Keep the beacon out of the GPU compositor (/duo): marked
    // data-gpu-ignore, the browser keeps painting it above the canvas
    // instead of the mirror hiding it. The script adds its container to
    // <body> later.
    const mark = () => {
      const el = document.getElementById('beacon-container')
      el?.setAttribute('data-gpu-ignore', '')
      return Boolean(el)
    }
    let observer = null
    if (!mark()) {
      observer = new MutationObserver(() => {
        if (mark()) observer.disconnect()
      })
      observer.observe(document.body, { childList: true })
    }

    return () => {
      observer?.disconnect()
      if (window.Beacon) {
        window.Beacon('destroy')
      }
    }
  }, [])

  return null
}
